import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=466a5ff2&scoped=true&"
import script from "./Permission.vue?vue&type=script&lang=js&"
export * from "./Permission.vue?vue&type=script&lang=js&"
import style0 from "./Permission.vue?vue&type=style&index=0&id=466a5ff2&lang=sass&scoped=true&"
import style1 from "./Permission.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466a5ff2",
  null
  
)

export default component.exports